import React, { useMemo, useRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Bread from '../components/Breadcrumb'
import './index.less'
import { Input } from 'antd'
import { AspirationsBread, EGetHotSearch } from '../../models/constants'
import HotArticle from '../components/hotArticle'
import ArticleList from '../components/list'

import { effect, useStore, reducer } from '../../dva16'
import { NInfo, EGetInfo, RSetState, EGetCategory, EGetTopic, EGetSearch } from '../../models/constants'
import { immerable } from 'immer'

const handleClickTopic = (id) => {
  if (id) {
    reducer(NInfo, RSetState, { topicID: id })
    effect(NInfo, EGetInfo)
  } else {
    reducer(NInfo, RSetState, { topicID: null, start: true })
    effect(NInfo, EGetInfo)
  }
}

function Aspirations() {
  let { infoList, topicID, category, hotList } = useStore(NInfo)
  const [query, setQuery] = useState(null)
  const [categoryID, setCategoryID] = useState('')
  const [categoryLo, setCategory] = useState('')

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      setQuery(e.target.value)
      effect(NInfo, EGetSearch, { query: e.target.value, categoryID, type: '内部心声' })
    }
  }

  useEffect(() => {
    let value
    category.forEach((itm) => {
      if (itm.id === categoryID) {
        value = itm
      }
    })
    console.log(category,'category')
    setCategory(value)
  }, [category])

  useMemo(() => {
    computeUrl()
    window.addEventListener('hashchange', (e) => {
      let href = window.location.href
      if (href.indexOf('aspirations') >= 0) {
        computeUrl()
      }
    })
  }, [])
  function computeUrl() {
    let href = window.location.href
    let arr = href.split('?')
    let value = 2
    if (arr.length === 2) {
      value = Number(arr[1].replace(/[^0-9]/gi, ''))
    }
    setCategoryID(value)
    reducer(NInfo, RSetState, { categoryID: value, start: true })
    effect(NInfo, EGetHotSearch, { categoryID: value, isHot: 1 })
    effect(NInfo, EGetInfo)
    effect(NInfo, EGetCategory)
  }

  function computeCategory(type) {
    let value
    if (category) {
    }
    return value
  }

  return (
    <div id="container">
      <div id="aspirations">
        {Bread(AspirationsBread, categoryLo)}
        <div className="center">
          <div className="left">
            <div className="total">
              <div className="totalHeader">
                <div className="title">
                  <img style={{width: '70px', height: '72px', objectFit: 'contain'}} src={require('../static/logo.jpg')} alt="" />
                  <div className="name">
                    <p>{categoryLo ? categoryLo.name : ''}</p>
                    <span>版主：帝业工会</span>
                  </div>
                </div>
                <div className="num">
                  <div className="text">
                    <p>{categoryLo ? categoryLo.infoTodayCount : 0}</p>
                    <span>今日</span>
                  </div>
                  <div className="line"></div>
                  <div className="text">
                    <p>{categoryLo ? categoryLo.topicList.length : 0}</p>
                    <span>主题</span>
                  </div>
                </div>
              </div>
              <div className="totalFoot">
                <span onClick={() => handleClickTopic(null)} className={topicID === null ? 'checked' : ''}>
                  全部
                </span>
                {categoryLo &&
                  categoryLo.topicList.map((item, index) => (
                    <span className={topicID === item.id ? 'checked' : ''} key={index} onClick={() => handleClickTopic(item.id)}>
                      {item.name}
                    </span>
                  ))}
              </div>
            </div>
            <div className="list">
              <div className="listHeader">
                <div className="listLeft">
                  <img src={require('../static/new-2.svg')} alt="" />
                  <span>最新</span>
                  <img src={require('../static/fire-2.svg')} alt="" />
                  <span>热门</span>
                </div>
                <div className="listRight">
                  <Input placeholder="搜索关键字" onKeyUp={(e) => handleKeyUp(e)} />
                </div>
              </div>
              {ArticleList(
                infoList.data,
                { total: infoList.total, pageSize: infoList.perPage, defaultPage: infoList.page },
                { query, categoryID }
              )}
            </div>
          </div>
          <div className="right">
            <div
              onClick={() => {
                document.documentElement.scrollTop = document.body.scrollTop = 0
                window.location.href = `#/edit/${categoryID}`
              }}
              className="edit"
            >
              <img src={require('../static/write.svg')} alt="" />
              <span>发帖</span>
            </div>
            {hotList ? HotArticle('热门帖', hotList.data) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Aspirations
